import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as actions from '../+state/actions/educational-content.actions';
import * as selectors from '../+state/selectors/educational-content.selectors';

@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  content$ = this.store.pipe(select(selectors.getEducationalContent));

  constructor(private readonly store: Store) {}

  init() {
    this.store.dispatch(actions.loadAEMContent());
  }
}
